<template>
  <div>
    <div
      v-if="checks.every((c) => c.isSuccess)"
      class="d-flex justify-content-center"
    >
      <span class="text-success font-weight-bold">{{
        T(
          "Web.InvoiceInspectionsPage.Preview.AllLinesPassed",
          "All lines passed"
        )
      }}</span>
    </div>
    <div v-else>
      <div class="check-list">
        <div class="header">
          <span>{{ T("Web.Generic.Invoices.LineId", "Line id") }}</span>
          <span>{{ T("Web.Generic.Invoices.Quantity", "Quantity") }}</span>
          <span>{{ T("Web.Generic.Invoices.UnitPrice", "Unit price") }}</span>
          <span
            >{{ T("Web.Generic.Invoices.LineTotal", "Line total") }} ({{
              T(
                "Web.InvoiceInspectionsPage.InvoicedExpected",
                "Invoiced/expected"
              )
            }})</span
          >
          <span></span>
        </div>
        <div
          class="check"
          :class="{
            'table-danger': content.includes(check.checkId),
            'table-primary': !content.includes(check.checkId),
          }"
          v-for="(check, index) in failedChecks"
          :key="index"
          @mouseenter="$emit('line-higlighed', check.lineId)"
          @mouseleave="$emit('line-higlighed', null)"
        >
          <span>{{ check.lineNo }}</span>
          <span
            >{{ check.lineQuantity | toCurrency }} {{ check.lineUnit }}</span
          >
          <span>{{ check.lineUnitPrice | toCurrency }}</span>
          <span
            ><span class="text-primary font-weight-bold">{{
              check.expectedLineTotal | toCurrency
            }}</span>
            /
            <span class="text-danger font-weight-bold">{{
              check.foundLineTotal | toCurrency
            }}</span> </span
          ><span>
            <input
              type="checkbox"
              :checked="content.includes(check.checkId)"
              @change="toggleIncludeCheck(check.checkId)"
              @click.stop
          /></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BTabs, BTab } from "bootstrap-vue";
export default {
  components: {
    BTabs,
    BTab,
  },
  props: {
    value: {
      required: true,
    },
    checks: {
      required: true,
    },
  },
  data() {
    return {
      content: this.value,
    };
  },
  computed: {
    failedChecks() {
      return this.checks.filter((c) => !c.isSuccess);
    },
  },
  methods: {
    handleInput() {
      this.$emit("input", this.content);
    },
    toggleIncludeCheck(checkId) {
      if (this.content.includes(checkId))
        this.content.splice(this.content.indexOf(checkId), 1);
      else this.content.push(checkId);
      this.handleInput();
    },
  },
};
</script>

<style lang="scss" scoped>
.check-list {
  .header {
    display: flex;
    justify-content: space-between;
    align-items: left;
    padding: 0 10px;
    border-bottom: 1px solid;
    font-size: 11px;
    span {
      width: 20%;
      &:last-of-type {
        width: 5%;
      }
    }
  }
  .check {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #ebe9f1;
    padding: 5px 10px;

    span {
      width: 20%;
      &:last-of-type {
        width: 5%;
      }
    }

    &:hover {
      background-color: #ffe4ca;
    }
  }
}
</style>